import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { Display, Body } from '@shipt/design-system-typography'
import { MobileFilterButton } from '@/features/shop/components/ProductFilter/MobileFilterButton'
import { Row, Stack } from '@shipt/design-system-layouts'
import { type SearchCategory } from '@/features/shop/services/Search/types'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicCouponsFilterModal } from '@/features/shop/components/Modal/CouponsFilterModal/DynamicCouponsFilterModal'

type Props = {
  totalCoupons: number
  couponListUrl: string
  currentCategory?: SearchCategory
}

export const CouponsPageHeader = ({ totalCoupons, currentCategory, couponListUrl }: Props) => {
  const { openDialog } = useHandleDialog()

  const handleOnClickMobileFilter = () => {
    openDialog(DynamicCouponsFilterModal, { couponListUrl })
  }
  return (
    <Stack
      justify="space-between"
      align={{ base: 'center', md: 'start' }}
      marginBottom="lg"
      direction={{ base: 'row', md: 'column' }}
    >
      <TitleWrapper spacing="sm" align="center">
        <Display size="sm" as="h2">
          Coupons{currentCategory?.name ? `: ${currentCategory.name}` : ''}
        </Display>
        {totalCoupons >= 100 && (
          <Body variant="secondary" size="sm">
            {`${totalCoupons} ${totalCoupons > 1 ? 'results' : 'result'}`}
          </Body>
        )}
      </TitleWrapper>
      <MobileFilterButton
        onClick={handleOnClickMobileFilter}
        activeFiltersLength={currentCategory?.id ? 1 : 0}
      />
    </Stack>
  )
}

const TitleWrapper = styled(Row)`
  padding-bottom: 0.25rem;

  @media ${screenSizes.tablet} {
    width: 100%;
    border-bottom: 0.0625rem solid ${({ theme }) => theme.gray100};
  }
`
